export var SignAndVerifyInterpretedExecutors;
(function (SignAndVerifyInterpretedExecutors) {
    SignAndVerifyInterpretedExecutors["openFateChannel"] = "openFateChannel";
})(SignAndVerifyInterpretedExecutors || (SignAndVerifyInterpretedExecutors = {}));
//# sourceMappingURL=sign-and-verify-interpreted-executors.js.map